// extracted by mini-css-extract-plugin
module.exports = {"shopifyMsdSaving":"shopify-msd-saving__shopifyMsdSaving___27s15"};